import React from 'react';
import { defaultTheme, themes } from '../themes/index';
import { Provider } from 'react-redux';
import { store } from '../store';
import { StyledProvider } from './styledProvider';

type JourneyProviderProps = {
  theme?: 'sodimac' | 'falabella';
};

export const JourneyProvider: React.FC<JourneyProviderProps> = ({ theme = defaultTheme, children }) => {
  const selectedTheme = themes.filter((item: any) => item.id === theme).pop();

  return (
    <StyledProvider theme={selectedTheme}>
      <Provider store={store}>{children}</Provider>
    </StyledProvider>
  );
};
